import { combineReducers } from '@ngrx/store';

import {
  isLoadingUpsellReducer as isLoadingUpsell
} from '@upsell/store/reducers/ui/is-loading-upsell.reducer';
import {
  isLoadingUpsellForDesktopReducer as isLoadingUpsellForDesktop
} from '@upsell/store/reducers/ui/is-loading-upsell-desktop.reducer';

export const UiUpsellRootReducer = combineReducers({
  isLoadingUpsell,
  isLoadingUpsellForDesktop
});
